import { Controller, useFormContext } from 'react-hook-form'

import { filingInstitutionIDTypes } from 'commons/types/dictionaries'
import { FF2, Select, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

const EMPTY_OPTION = { label: 'Not selected', value: '' }

export const IDType = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.idType"
      control={control}
      rules={{ validate: Validators.required.field }}
      render={({ field }) => (
        <FF2
          required
          label="81. Filing institution ID Type"
          field={field}
          input={(props) => (
            <Select
              {...props}
              data={filingInstitutionIDTypes}
              emptyOption={EMPTY_OPTION}
              data-qa="81. Filing institution ID Type"
              options-data-qa="81. Filing institution ID Type option"
            />
          )}
        />
      )}
    />
  )
}
